exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*.complementary-container {*/\n/*  color: #0097A78c;*/\n/*  background-color: ghostwhite;*/\n/*  padding: 20px;*/\n/*  text-align: right;*/\n/*}*/\n.mat-icon {\n  top: -2px;\n  position: relative;\n}\nbutton:focus {\n  outline: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/company-custom-form/companyCustomForm.style.css
// module id = 1060
// module chunks = 3